<template>
  <div class="media-results playlist-results">
    <PlaylistCard
      v-for="(item, index) in items"
      :key="`${item.meta?.source}-${index}`"
      :item="item"
    />
  </div>
</template>

<script>
import PlaylistCard from './PlaylistCard.vue'

// Выдача YouTube-плейлиста: блоки одиночной выдачи друг за другом (.media-results, как ResultDefault).
export default {
  name: 'PlaylistResult',
  components: { PlaylistCard },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
